/**
 * @generated SignedSource<<b0edb5f338c037909032db2cddbab88c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGifting_transaction$data = {
  readonly isGiftEligible: boolean | null;
  readonly " $fragmentType": "CheckoutGifting_transaction";
};
export type CheckoutGifting_transaction$key = {
  readonly " $data"?: CheckoutGifting_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGifting_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGifting_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGiftEligible",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "f0082e969a2f8972dafd0d2a3156f6d2";

export default node;
